export const RQ_CREATE_DIGI_DOCUMENT_SIGNER_CONFIGURATION_API = {
  url: 'v1/digi-document-signer-configuration/create',
  method: 'POST',
  auth: true,
};

export const RQ_GET_DIGI_DOCUMENT_SIGNER_CONFIGURATION_ALL_API = {
  url: 'v1/digi-document-signer-configuration/all',
  method: 'GET',
  auth: true,
};

export const RQ_SEARCH_DIGI_DOCUMENT_SIGNER_CONFIGURATION_API = {
  url: 'v1/digi-document-signer-configuration/search?',
  method: 'GET',
  auth: true,
  search: true,
};

export const RQ_UPDATE_DIGI_DOCUMENT_SIGNER_CONFIGURATION_API = {
  url: 'v1/digi-document-signer-configuration/update',
  method: 'PUT',
  auth: true,
};

export const RQ_GET_DIGI_DOCUMENT_SIGNER_CONFIGURATION_FIND_BY_ID_API = {
  url: 'v1/digi-document-signer-configuration/findById/<%= id %>',
  method: 'GET',
  search: true,
  auth: true,
};
